var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from "react";
import { Link } from "../Link";
import { fixedForwardRef } from "../../../common/LibComponentProps";
import { CollapseContext } from "../../core";
var UnwrappedDropdownMenuLink = function (props, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
ref) {
    var isCurrentPage = props.isCurrentPage, disabled = props.disabled, onClick = props.onClick, children = props.children, className = props.className, style = props.style, otherProps = __rest(props, ["isCurrentPage", "disabled", "onClick", "children", "className", "style"]);
    var aClass = "ssg-dropdown-menu__link fr-nav__link";
    if (className) {
        aClass += " " + className;
    }
    var collapseContextValue = useContext(CollapseContext);
    var closeCollapse = undefined;
    if (collapseContextValue) {
        closeCollapse = collapseContextValue.closeCollapse;
    }
    var onClickLink = function (event) {
        if (closeCollapse) {
            closeCollapse();
        }
        if (onClick) {
            onClick(event);
        }
    };
    return (React.createElement(Link, __assign({}, otherProps, { ref: ref, className: aClass, style: style, "aria-current": isCurrentPage, "aria-disabled": disabled, onClick: onClickLink }), children));
};
var DropdownMenuLink = fixedForwardRef(UnwrappedDropdownMenuLink);
export default DropdownMenuLink;
